import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { IMAGES } from "../constants";

const ImageCarousel: React.FC = () => {
  const slides = IMAGES.gallery;
  const [activeIndex, setActiveIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  useEffect(() => {
    if (isPaused) {
      return;
    }

    const timer = window.setInterval(() => {
      setActiveIndex((current) => (current + 1) % slides.length);
    }, 5200);

    return () => window.clearInterval(timer);
  }, [isPaused, slides.length]);

  const goPrev = () => {
    setActiveIndex((current) => (current - 1 + slides.length) % slides.length);
  };

  const goNext = () => {
    setActiveIndex((current) => (current + 1) % slides.length);
  };

  return (
    <section
      aria-label="Galería visual de experiencias"
      className="relative w-full overflow-hidden bg-zinc-950 py-10 md:py-12"
      onMouseEnter={() => setIsPaused(true)}
      onMouseLeave={() => setIsPaused(false)}
      onFocusCapture={() => setIsPaused(true)}
      onBlurCapture={() => setIsPaused(false)}
    >
      <div className="relative mx-auto w-full">
        <div className="overflow-hidden">
          <div
            className="flex transition-transform duration-1000 ease-[cubic-bezier(0.22,1,0.36,1)]"
            style={{ transform: `translateX(-${activeIndex * 100}%)` }}
          >
            {slides.map((src, index) => (
              <div key={src} className="w-full flex-shrink-0 px-4 md:px-6 lg:px-8">
                <img
                  src={src}
                  alt={`Galería AsiViajo ${index + 1}`}
                  className={`w-full rounded-3xl object-cover transition-all duration-1000 ease-[cubic-bezier(0.22,1,0.36,1)] ${
                    index === activeIndex
                      ? "h-[52vh] scale-100 opacity-100 shadow-[0_24px_64px_rgba(0,0,0,0.45)] md:h-[64vh] lg:h-[72vh]"
                      : "h-[52vh] scale-[1.03] opacity-90 md:h-[64vh] lg:h-[72vh]"
                  }`}
                  loading={index === 0 ? "eager" : "lazy"}
                />
              </div>
            ))}
          </div>
        </div>

        <button
          type="button"
          onClick={goPrev}
          className="absolute left-5 top-1/2 -translate-y-1/2 rounded-full border border-white/35 bg-black/40 p-2.5 text-white backdrop-blur-sm transition hover:scale-105 hover:bg-black/60 md:left-7"
          aria-label="Imagen anterior"
        >
          <ChevronLeft className="h-5 w-5 md:h-6 md:w-6" />
        </button>

        <button
          type="button"
          onClick={goNext}
          className="absolute right-5 top-1/2 -translate-y-1/2 rounded-full border border-white/35 bg-black/40 p-2.5 text-white backdrop-blur-sm transition hover:scale-105 hover:bg-black/60 md:right-7"
          aria-label="Siguiente imagen"
        >
          <ChevronRight className="h-5 w-5 md:h-6 md:w-6" />
        </button>

        <div className="mt-6 flex items-center justify-center gap-2">
          {slides.map((slide, index) => (
            <button
              key={slide}
              type="button"
              onClick={() => setActiveIndex(index)}
              aria-label={`Ir a imagen ${index + 1}`}
              className={`rounded-full transition-all ${
                index === activeIndex
                  ? "h-2.5 w-9 bg-brand-pink"
                  : "h-2.5 w-2.5 bg-zinc-500 hover:bg-zinc-300"
              }`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ImageCarousel;
